export enum ContentDeleteActionType {
  DELETE_DRAFT = "DELETE_DRAFT",
  DELETE_DRAFT_IF_BLANK = "DELETE_DRAFT_IF_BLANK",
  MOVE_TO_TRASH = "MOVE_TO_TRASH",
 	PURGE_FROM_TRASH = "PURGE_FROM_TRASH",
}

export interface DeleteContentMutation_deleteContent {
	__typename: "DeleteContentResponsePayload";
	contentId: string;
	wasDeleted: boolean;
}

export interface DeleteContentMutation {
  deleteContent: DeleteContentMutation_deleteContent;
}

export interface DeleteContentMutationVariables {
  contentId: string;
  action: ContentDeleteActionType;
}
